import React from 'react';
import './LegalPages.css';

const Privacy: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <h1>Privacy Policy</h1>
          <p className="legal-date">Last Updated: December 23, 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>🔒 Your Privacy is Our Priority</h2>
            <p>
              At TextCompare.in, we are committed to protecting your privacy. This Privacy Policy 
              explains how we handle your information when you use our text comparison tool.
            </p>
          </section>

          <section className="legal-section">
            <h2>📊 Data Collection</h2>
            <h3>What We DON'T Collect:</h3>
            <ul>
              <li>We do NOT store any text you compare</li>
              <li>We do NOT upload your files to any server</li>
              <li>We do NOT track your personal information</li>
              <li>We do NOT use cookies for tracking</li>
              <li>We do NOT share your data with third parties</li>
            </ul>

            <h3>What We MAY Collect:</h3>
            <ul>
              <li><strong>Anonymous Analytics:</strong> Basic usage statistics (page views, browser type) via privacy-friendly analytics</li>
              <li><strong>Technical Data:</strong> IP address (for security purposes only, not stored)</li>
              <li><strong>Local Storage:</strong> Theme preference (dark/light mode) stored in your browser only</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>💻 How It Works</h2>
            <p>
              TextCompare.in operates entirely in your browser. All text comparisons happen 
              client-side using JavaScript. Your text never leaves your device.
            </p>
            <div className="info-box">
              <strong>100% Client-Side Processing</strong>
              <p>Your data stays on your device. No server uploads. Complete privacy guaranteed.</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>🍪 Cookies</h2>
            <p>
              We use minimal essential cookies only:
            </p>
            <ul>
              <li><strong>Theme Preference:</strong> Remembers your dark/light mode choice (stored locally)</li>
              <li><strong>No Tracking Cookies:</strong> We do not use advertising or tracking cookies</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>🔐 Data Security</h2>
            <p>
              Since we don't collect or store your text data:
            </p>
            <ul>
              <li>There's no risk of data breaches</li>
              <li>Your sensitive information remains private</li>
              <li>You can use the tool offline without concerns</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>👶 Children's Privacy</h2>
            <p>
              Our service does not knowingly collect information from children under 13. 
              The tool is safe for all ages as no personal data is collected.
            </p>
          </section>

          <section className="legal-section">
            <h2>🌍 International Users</h2>
            <p>
              TextCompare.in is accessible worldwide. Since all processing happens in your 
              browser, there are no cross-border data transfers.
            </p>
          </section>

          <section className="legal-section">
            <h2>✏️ Changes to Privacy Policy</h2>
            <p>
              We may update this Privacy Policy occasionally. Changes will be posted on this page 
              with an updated "Last Updated" date. Continued use of the service constitutes acceptance 
              of any changes.
            </p>
          </section>

          <section className="legal-section">
            <h2>📧 Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us:
            </p>
            <ul>
              <li>Email: psachin375@gmail.com</li>
              <li>Website: <a href="/">textcompare.in</a></li>
            </ul>
          </section>

          <div className="legal-footer-note">
            <p>
              <strong>Note:</strong> TextCompare.in is a free tool designed with privacy in mind. 
              We believe your data is yours, and we've built our tool to ensure it stays that way.
            </p>
          </div>
        </div>

        <div className="legal-actions">
          <a href="/" className="btn-primary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default Privacy;